// extracted by mini-css-extract-plugin
module.exports = {"container":"CustomPage_container__3n8F5","customContentHolder":"CustomPage_customContentHolder__2gLYT"};